import { DocumentDetailModalForm } from "./DocumentDetailModalForm"

const DocumentDetailModalFormWrapper = () => {
    return (<DocumentDetailModalForm />)
}

export { DocumentDetailModalFormWrapper }